import React, { useMemo } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { useGetGeneralSettingsQuery } from '../../services/settingsSlice'

import './styles.css'

interface DrawerNavProps {
  onLinkClick?: () => void;
}

const DrawerNav: React.FC<DrawerNavProps> = React.memo(({ onLinkClick }) => {
  const location = useLocation();
  const currentRoute = '/company-settings';

  const activeTab = location.pathname;

  const handleClick = () => {
    if (onLinkClick) {
      onLinkClick();
    }
  };

  // Check if user is oogwai user
  const { data: userData } = useGetGeneralSettingsQuery('', {
    refetchOnMountOrArgChange: true,
  })

  const getEmail = useMemo(() => {
    const localEmail = localStorage.getItem("oogw.ai_user_email")
    const userEmail = userData?.settings?.email
    return (!localEmail || localEmail === "null") ? userEmail : localEmail
  }, [userData])

  const oogwaiUser = getEmail && getEmail !== "info@oogw.ai" && getEmail !== "demo@oogw.ai" && getEmail.endsWith('@oogw.ai') ? true : false

  return (
    <div id="drawer-navigation" aria-labelledby="drawer-navigation-label" className='drawer-navigation'>
      <div className="p-4 overflow-y-auto">
        <ul className="font-medium">
          <li className={`${activeTab === currentRoute + '/general' ? 'isActive' : ''}`} data-tour="profile-settings">
            <Link to={currentRoute + '/general'} className="flex items-center rounded-lg group" onClick={handleClick}>
              <span>General</span>
            </Link>
          </li>
          <li className={`${activeTab === currentRoute + '/notifications' ? 'isActive' : ''}`} data-tour="notifications-settings">
            <Link to={currentRoute + '/notifications'} className="flex items-center rounded-lg group" onClick={handleClick}>
              <span className="flex-1 whitespace-nowrap">Notifications</span>
            </Link>
          </li>
          <li className={`${activeTab === currentRoute + '/security' ? 'isActive' : ''}`} data-tour="security-settings">
            <Link to={currentRoute + '/security'} className="flex items-center rounded-lg group" onClick={handleClick}>
              <span className="flex-1 whitespace-nowrap">Security</span>
            </Link>
          </li>
          {/* <li className={`${activeTab === currentRoute+'/teams' ? 'isActive': ''}`}>
            <Link to={currentRoute+'/teams'} className="flex items-center rounded-lg group" onClick={handleClick}>
            <span className="flex-1 whitespace-nowrap">Teams</span>
            </Link>
            </li> */}
          <li className={`${activeTab === currentRoute + '/plan' || activeTab === currentRoute + '/checkout-payment' ? 'isActive' : ''}`} data-tour="billing-settings">
            <Link to={currentRoute + '/plan'} className="flex items-center rounded-lg group" onClick={handleClick}>
              <span className="flex-1 whitespace-nowrap">Plan</span>
            </Link>
          </li>
          <li className={`${activeTab === currentRoute + '/feedback-history' ? 'isActive' : ''}`} data-tour="feedback-settings">
            <Link to={currentRoute + '/feedback-history'} className="flex items-center rounded-lg group" onClick={handleClick}>
              <span className="flex-1 whitespace-nowrap">Feedback History</span>
            </Link>
          </li>
          {/* <li className={`${activeTab === currentRoute+'/billing' ? 'isActive': ''}`}>
            <Link to={currentRoute+'/billing'} className="flex items-center rounded-lg group" onClick={handleClick}>
              <span className="flex-1 whitespace-nowrap">Billing</span>
            </Link>
          </li> */}
          <li className={`${activeTab === currentRoute + '/referrals' ? 'isActive' : ''}`} data-tour="referrals-settings">
            <Link to={currentRoute + '/referrals'} className="flex items-center rounded-lg group" onClick={handleClick}>
              <span className="flex-1 whitespace-nowrap">Referrals</span>
            </Link>
          </li>
          {/* {oogwaiUser && ( */}
            <li className={`${activeTab === currentRoute + '/audit-log' ? 'isActive' : ''}`}>
              <Link to={currentRoute + '/audit-log'} className="flex items-center rounded-lg group" onClick={handleClick}>
                <span className="flex-1 whitespace-nowrap">Audit Logs</span>
              </Link>
            </li>
          {/* )} */}
        </ul>
      </div>
    </div>
  );
});

DrawerNav.displayName = 'DrawerNav';

export default DrawerNav
